var map = {
	"./apt": 28,
	"./apt.ts": 28,
	"./brew": 8507,
	"./brew.ts": 8507,
	"./cat": 6519,
	"./cat.ts": 6519,
	"./chmod": 6190,
	"./chmod.ts": 6190,
	"./chown": 6074,
	"./chown.ts": 6074,
	"./cp": 8024,
	"./cp.ts": 8024,
	"./curl": 6733,
	"./curl.ts": 6733,
	"./df": 3173,
	"./df.ts": 3173,
	"./du": 628,
	"./du.ts": 628,
	"./echo": 8386,
	"./echo.ts": 8386,
	"./find": 5220,
	"./find.ts": 5220,
	"./git": 2339,
	"./git.ts": 2339,
	"./grep": 6707,
	"./grep.ts": 6707,
	"./head": 6709,
	"./head.ts": 6709,
	"./kill": 4228,
	"./kill.ts": 4228,
	"./killall": 1636,
	"./killall.ts": 1636,
	"./less": 9578,
	"./less.ts": 9578,
	"./ls": 346,
	"./ls.ts": 346,
	"./mkdir": 3016,
	"./mkdir.ts": 3016,
	"./more": 8490,
	"./more.ts": 8490,
	"./mv": 4640,
	"./mv.ts": 4640,
	"./nano": 1485,
	"./nano.ts": 1485,
	"./node": 1375,
	"./node.ts": 1375,
	"./npm": 5234,
	"./npm.ts": 5234,
	"./nvm": 1056,
	"./nvm.ts": 1056,
	"./pnpm": 8110,
	"./pnpm.ts": 8110,
	"./ps": 3150,
	"./ps.ts": 3150,
	"./pwd": 5860,
	"./pwd.ts": 5860,
	"./python": 7421,
	"./python.ts": 7421,
	"./python3": 3460,
	"./python3.ts": 3460,
	"./rm": 6950,
	"./rm.ts": 6950,
	"./rmdir": 4327,
	"./rmdir.ts": 4327,
	"./scp": 3513,
	"./scp.ts": 3513,
	"./ssh": 2449,
	"./ssh.ts": 2449,
	"./tail": 9197,
	"./tail.ts": 9197,
	"./top": 1012,
	"./top.ts": 1012,
	"./touch": 5476,
	"./touch.ts": 5476,
	"./uname": 1799,
	"./uname.ts": 1799,
	"./vim": 4180,
	"./vim.ts": 4180,
	"./wget": 8632,
	"./wget.ts": 8632,
	"./yarn": 2961,
	"./yarn.ts": 2961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4534;